import { computed } from 'mobx';
import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class ClientGDPRSummaryDataService extends DataService<typeof Model.GDPR.Logic.ViewModels.ClientGDPRSummary, Model.GDPR.Logic.ViewModels.ClientGDPRSummary, ClientGDPRSummary> {
	protected map(entity: Model.GDPR.Logic.ViewModels.ClientGDPRSummary): ClientGDPRSummary {
		return new ClientGDPRSummaryModel(entity);
    }

	public static make(ctx?: any): ClientGDPRSummaryDataService {
		return new ClientGDPRSummaryDataService(ctx, ctx => ctx.ClientsGDPRSummaries);
    }
}

export class ClientGDPRSummaryModel extends EntityModel<Model.GDPR.Logic.ViewModels.ClientGDPRSummary, ClientGDPRSummary> implements ClientGDPRSummary {
	@property<ClientGDPRSummaryModel>(o => o.entity.id, (o, value) => o.entity.id = value)
    public id: number;

	@property<ClientGDPRSummaryModel>(o => o.entity.displayName, (o, value) => o.entity.displayName = value)
    public displayName: string;
	@property<ClientGDPRSummaryModel>(o => o.entity.birthDate, (o, value) => o.entity.birthDate = value)
	public birthDate: string;
	@property<ClientGDPRSummaryModel>(o => o.entity.email, (o, value) => o.entity.email = value)
	public email: string;
	@property<ClientGDPRSummaryModel>(o => o.entity.contacts, (o, value) => o.entity.contacts = value)
	public contacts: ContactItem[];
	@property<ClientGDPRSummaryModel>(o => o.entity.type, (o, value) => o.entity.type = value)
	public type: Model.Crm.Domain.Models.ClientType;
	@property<ClientGDPRSummaryModel>(o => o.entity.contactsString, (o, value) => o.entity.contactsString = value)
	public contactsString:string
}



// WEBPACK FOOTER //
// ./src/app/gdpr/clients/list/client-gdpr.data.ts